exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.md-tabs-content table thead {\n  display: table-header-group;\n}\n", ""]);

// exports
